import React from "react"
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useDisclosure,
  Box,
} from "@chakra-ui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import Filter from "./filter"

const FilterComponent = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()
  return (
    <>
      <div className="sc-filter-desktop">
        <Box w="300px" margin="5">
          <Filter />
        </Box>
      </div>
      <div className="sc-filter-mobile">
        <Box textAlign="right">
          <Button ref={btnRef} onClick={onOpen}>
            <FontAwesomeIcon className="sc-gallery-icon" icon={faFilter} />
            Filter
          </Button>
        </Box>

        <Drawer
          isOpen={isOpen}
          placement="right"
          onClose={onClose}
          finalFocusRef={btnRef}
        >
          <DrawerOverlay>
            <DrawerContent padding="20px">
              <DrawerCloseButton />
              <DrawerHeader>Filter</DrawerHeader>
              <DrawerBody overflowY="auto">
                <Filter />
              </DrawerBody>
            </DrawerContent>
          </DrawerOverlay>
        </Drawer>
      </div>
    </>
  )
}

export default FilterComponent
